import '../App.css';
import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import ClipLoader from "react-spinners/ClipLoader";


const API_KEY = 'TWIGFARM_API_GATEWAY_WEBSOCKET'; // dev & prod the same

// const MODE = 'PROD';
const MODE = process.env.REACT_APP_RELEASE_MODE;;
const webSocketUrl =
    MODE === 'DEV'
        ? 'wss://rf6mz048k6.execute-api.ap-northeast-2.amazonaws.com/dev'
        : 'wss://pb27uyr3dk.execute-api.ap-northeast-2.amazonaws.com/ws1';

const API_BASEURL =
    MODE === 'DEV'
        ? 'https://seqtlevcy8.execute-api.ap-northeast-2.amazonaws.com/dev'
        : 'https://x7ztt0l1yg.execute-api.ap-northeast-2.amazonaws.com/v1';



function Upload() {
    // const [uploadUrls, setUploadUrls] = useState([]);
    const [data, setData] = useState({});
    // const [s3Key, setS3Key] = useState();
    // const [s3Bucket, setS3Bucket] = useState();
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const wsRef = useRef(null);

    useEffect(async () => {
        const ws = new WebSocket(webSocketUrl);
        wsRef.current = ws;

        ws.onopen = () => {
            handleWebsocketOpen();
        };
        ws.onmessage = async (event) => {
            handleWebsocketMessage(event);
        };
        ws.onclose = () => {
            handleWebsocketClose();
        };

        return () => {
            // Close WebSocket connection on unmount
            if (ws) {
                ws.close();
            }
        };
    }, []);

    const connect = () => {
        let ws = wsRef.current;

        if (ws.readyState !== WebSocket.OPEN) {
            console.log('Attempting to reconnect...');
            ws.close();
            wsRef.current = new WebSocket(webSocketUrl);
            ws = wsRef.current;
        }
        ws.onopen = () => {
            handleWebsocketOpen();
        };
        ws.onmessage = async (event) => {
            handleWebsocketMessage(event);
        };
        ws.onclose = () => {
            handleWebsocketClose();
        };
    };

    const handleWebsocketOpen = () => {
        console.log('Websocket connected');
        setLoading(false);
    };
    const handleWebsocketMessage = async (event) => {
        console.log('event.data: ', event.data);
        const response = JSON.parse(event.data);
        if (response.type === 'heartbeat') {
            return;
        }

        console.log('response.state: ', response.state);
        if (response.state === 'parsed') {
            // loadImageParsedJson(response.data);
        } else if (response.state === 'translated') {
            // setTranslatedJson(response.data);
        }
        // await requestImageUrls(response.translation_id);
        // setLoading(false);
    };

    const handleWebsocketClose = () => {
        console.log('WebSocket disconnected');
        // Attempt to reconnect after a delay
        setTimeout(() => {
            console.log('Reconnecting to WebSocket server...');
            connect();
        }, 5000);
    };
    const step1Oocr= async  (s3Bucket, s3Key)=>  {
        const response = await axios({
            "method": "POST",
            "url": "https://seqtlevcy8.execute-api.ap-northeast-2.amazonaws.com/dev/step1-ocr",
            "headers": {
                "x-api-key": API_KEY,
                "Content-Type": "application/json; charset=utf-8"
            },
            "data": {
                "s3_bucket": s3Bucket,
                "s3_key": s3Key
            }
        }).then()
        if(response.status !== 200){
            alert("ocr error")
            return false
        }

        setTimeout(function (){
            let translationId = response.data.translation_id
            alert(response.data.message)
            window.location.href ='/Complete?translation_id='+translationId;
            setLoading(false)
        }, 5000);

    }
    const uploadImage = async (uploadUrls, fileNameList)=> {
        console.log(uploadUrls)
        console.log(fileNameList)
        for (let i = 0; i < fileNameList.length; i++) {
            let file = fileNameList[i];
            let url = "";


            for (let j = 0; j < uploadUrls.length; j++) {
                let upload = uploadUrls[j];
                if(upload[file['fileName']]){
                    url = upload[file['fileName']]
                }
            }
            console.log("url="+url)
            if(url){
                const result = await axios.put(url, file["file"]);
                console.log("result");
                console.log(result);
            }else{
                console.log("url 없음")
            }
        }


        console.log(data)



        //
        return true;
    }

    const getUploadUrl = async (fileList)  => {

        let fileNameList = []
        let param = ''
        for (const files of fileList) {
            let fileName = files.name
            if(param === ''){
                param +="file_names="+fileName;
            }else{
                param +="&file_names="+fileName;
            }

            fileNameList.push({
                "fileName" : fileName,
                "file" : files
            })
        }

        //파일명으로 다시 정렬
        fileNameList.sort(function(a, b) {
            return a.fileName < b.fileName ? -1 : a.fileName > b.fileName ? 1 : 0;
        });


        axios({
            "method": "GET",
            "url": `${API_BASEURL}/upload-urls?${param}`,
            "headers": {
                "x-api-key": API_KEY
            }
        }).then(response => {
            console.log("response");

            console.log(response)
            const uploadUrls = response.data.upload_urls
            const S3Bucket = response.data.s3_bucket
            const S3Key = response.data.s3_key
            setData(response.data)
            // setS3Bucket(S3Bucket)
            // setS3Key(S3Key)
            //
            // setUploadUrls(uploadUrls);
            const resilt = uploadImage(uploadUrls, fileNameList, S3Bucket, S3Key)

            console.log("resilt : " +resilt);
            resilt.then(() =>{

                let send = setInterval(function (){
                    // console.log("111="+S3Bucket)
                    // console.log("111="+S3Key)
                    // console.log(data)
                    if(S3Bucket && S3Key){
                        step1Oocr(S3Bucket, S3Key);
                        clearInterval(send)
                    }
                }, 1000)
            });
            return response.data;
        }).catch(error => {
            console.error(error);
        })


    }
    const onChangeFile = async (e) => {
        const files = e.target.files;

        setFiles(files)
        // const fd = new FormData();
        // let fileList = [];
        // for (let i = 0; i < files.length; i++) {
        //     fileList.push(files[i])
        //     fd.append('img', files[i])
        // }
        // getUploadUrl(fileList)
    }

    const checkButton = function (){
        if (files.length === 0){
            alert('파일을 선택해 주세요.')
            return;
        }
        setLoading(true)
        getUploadUrl(files)
    }
    const stopEvent = (e) => {
        e.preventDefault();
    }

    return (
        <form className="file-form" onSubmit={stopEvent}>
            <div className="file-form-input-wrap">
                <label role="button">
                    <input accept="image/*" type="file" multiple onChange={onChangeFile}/>
                    <svg viewBox="0 0 24 24" fill='#007bff'>
                        <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H15v-8h5V8l-6-6zm-1 7V3.5L18.5 9H13zm4 12.66V16h5.66v2h-2.24l2.95 2.95-1.41 1.41L19 19.41v2.24h-2z"></path>
                    </svg>
                    <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
                </label>
                <div className="file-form-desc">
                    {files.length === 0 ?
                        <span>Click to Upload</span>
                        : <span> {files.length} file Select</span>
                    }

                </div>
            </div>
            { !loading &&
                <button className="step1-button" onClick={() => {
                    // let s3_bucket ="kidari.api.private"
                    // let  s3_key = "ai_jp/originals/7991ff1a-44d0-4cc6-8cf9-283463f1af05"
                    // step1Ocr(s3_bucket, s3_key)
                    checkButton()
                    setTimeout(function (){
                        setLoading(false)
                    }, 10000)
                }} disabled={false}>
                    START OCR
                </button>
            }

            {/* 업로드 시작하면 아래 버튼으로 교체 */}
            { loading &&
                <button className="reset-button" onClick={() => {
                }} disabled={true} >
                    <ClipLoader color="##fff" size={10}/> START OCR
                </button>
            }
        </form>
    );
}

export default Upload;
